import { getContactDetails, getLinks } from "@stepapp/core";
import { AppStorage } from "../services/AppStorage";

export const useAppLinks = () => {
  const countryCode = AppStorage().get("countryCode");

  const links = getLinks(countryCode);

  return links;
};

export const useContactDetails = () => {
  const countryCode = AppStorage().get("countryCode");

  const contact = getContactDetails(countryCode);

  return contact;
};
